module.exports = "<great-component modifier=\"primary\"></great-component>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src-docs/app/snippets/primary-example.html
 ** module id = 11
 ** module chunks = 2
 **/